export default __webpack_public_path__ + "static/soltera-specs-3828b2bdf943a06657734227bffb54f5.jpg";